<template>
    <span :class="{ 'truncate': truncate }">
        <template v-if="column === 'name'">
            <nio-optional :value="fullName" />
        </template>
        <template v-if="column === 'phone'">
            <contact-phones :contact="contact" />
        </template>
        <template v-if="column === 'locale'">
            {{ locale }}
        </template>
        <template v-if="column === 'sentStatus'">
            <sms-status :contact="contact" :sent="contact.message_sent" />
        </template>
        <template v-if="column === 'reply'">
            <nio-icon
                class="text-lg"
                :class="[statusClassName, { 'cursor-pointer': conversation }]"
                :name="statusIcon"
                @click="goToConversation"
                v-tooltip="{ content: contact.reply, allowHTML: true }"
            />
        </template>
        <template v-if="column === 'actions'">
            <div class="space-x-2">
                <button
                    class="link-gray text-base"
                    :class="{ 'disabled': !conversation }"
                    @click="goToConversation"
                    v-tooltip="$t('campaigns.contactListing.actions.goToConversation')"
                >
                    <nio-icon name="regular/messages-bubble-search" />
                </button>
                <button
                    class="link-gray text-base"
                    @click="$emit('delete')"
                    v-tooltip="$t('campaigns.contactListing.actions.removeFromCampaign')"
                >
                    <nio-icon name="regular/bin-2-alternate" />
                </button>
            </div>
        </template>
    </span>
</template>

<script>
    import { mapState } from 'vuex';

    import ContactPhones from '@/components/ContactPhones.vue';
    import SmsStatus from '@/components/SmsStatus.vue';

    export default {
        components: {
            ContactPhones,
            SmsStatus,
        },

        props: {
            column: {
                type: String,
                required: true,
            },
            contact: {
                type: Object,
                required: true,
            },
            truncate: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            fullName() {
                return this.formatFullName(this.contact);
            },

            locale() {
                return this.formatLocale(this.contact.locale);
            },

            conversation() {
                return this.contact.conversations ? this.contact.conversations[0] : null;
            },

            statusIcon() {
                if (this.contact.reply) {
                    return 'bold/check-circle-1';
                }

                return 'bold/subtract-circle';
            },

            statusClassName() {
                if (this.contact.reply) {
                    return 'text-green-500';
                }

                return 'text-gray-500';
            },
        },

        methods: {
            goToConversation() {
                if (!this.conversation) {
                    return;
                }

                this.$router.push({
                    name: 'chat',
                    params: {
                        id: this.conversation.id,
                    },
                });
            },
        },
    };
</script>
